export const DEFAULT_WINDOW_WIDTH = 640
export const DEFAULT_WINDOW_HEIGHT = 480
export const MIN_WINDOW_WIDTH = 320
export const MIN_WINDOW_HEIGHT = 200

export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max)
}

export function cascadePosition(index, baseX = 80, baseY = 60, step = 30) {
  const offset = (index % 10) * step
  return { x: baseX + offset, y: baseY + offset }
}

export function dragPosition(startX, startY, deltaX, deltaY, width, height) {
  const maxX = Math.max(0, window.innerWidth - width)
  const maxY = Math.max(0, window.innerHeight - 48 - height)

  return {
    x: clamp(startX + deltaX, 0, maxX),
    y: clamp(startY + deltaY, 0, maxY),
  }
}

export function resizeDimensions(startWidth, startHeight, startX, startY, deltaX, deltaY, direction) {
  let width = startWidth
  let height = startHeight
  let x = startX
  let y = startY

  if (direction.includes("e")) width = startWidth + deltaX
  if (direction.includes("s")) height = startHeight + deltaY
  if (direction.includes("w")) {
    width = startWidth - deltaX
    x = startX + deltaX
  }
  if (direction.includes("n")) {
    height = startHeight - deltaY
    y = startY + deltaY
  }

  width = clamp(width, MIN_WINDOW_WIDTH, window.innerWidth - x)
  height = clamp(height, MIN_WINDOW_HEIGHT, window.innerHeight - 48 - y)
  x = clamp(x, 0, window.innerWidth - MIN_WINDOW_WIDTH)
  y = clamp(y, 0, window.innerHeight - 48 - MIN_WINDOW_HEIGHT)

  return { x, y, width, height }
}

export function maximizedGeometry() {
  return {
    x: 8,
    y: 8,
    width: window.innerWidth - 16,
    height: window.innerHeight - 56,
  }
}
